import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  DataStateChangeEventArgs,
  DatePickerEditCell,
  EditSettingsModel,
  GridComponent,
  PageSettingsModel,
  RowSelectEventArgs,
} from "@syncfusion/ej2-angular-grids";
import { IMyDpOptions } from "mydatepicker";
import { ToastrService } from "ngx-toastr";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CommonHttpService } from "src/app/common.service";
import { DateService } from "src/app/date.service";
import { GlobalComponent } from "src/app/global/global.component";
import { GeneralService } from "src/app/service/general.service";
import { runInThisContext } from "vm";
import { PurchaseListService } from "./purchase-request-dataservice";
import {
  functionpermission,
  GetPurchaseBase,
  purchaseBo,
  PurchaseReceiptBO,
  PurchaseRequestBO,
  servicedropdown,
  VendorBO,
} from "./purchase-request.model";
import { PurchaseRequestService } from "./purchase-request.service";

@Component({
  selector: "app-purchase-request",
  templateUrl: "./purchase-request.component.html",
  styleUrls: ["./purchase-request.component.scss"],
})
export class PurchaseRequestComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @Input() purchaseEmit = new purchaseBo();
  purchaseBO: PurchaseRequestBO = new PurchaseRequestBO();
  purchaseFileBo: PurchaseReceiptBO = new PurchaseReceiptBO();
  clientList: any;
  purchaseTypeList: any;
  purchaseType: string;
  vendorList: any;
  AuthList: any;
  payer: string;
  serviceName: string;
  purchaseId: string;
  isview = false;
  purchaselistBo: GetPurchaseBase = new GetPurchaseBase();
  acceptError: string;
  PurchaseStatusList: any;
  getAuthId: string;
  purchaseClientName: string;
  documentType: string = "";
  fileUpload: any;
  servicedropdown: [
    {
      key: null;
      value: null;
    }
  ];
  purchaseAuthGrid:any=[]
  showNoAgenyError=false
  vendor: VendorBO = new VendorBO();
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public initialPage: PageSettingsModel;
  @ViewChild("grid") public grid: GridComponent;
  public gridPurchase: Observable<DataStateChangeEventArgs>;
  public filterSettings: object;
  public formatDateOptions: object;
  public editSettings: EditSettingsModel;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    // disableSince: { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true,
  };
  stateList: any;
  form: FormGroup;
  constructor(
    private purchaseService: PurchaseRequestService,
    public dateservice: DateService,
    private cdr: ChangeDetectorRef,
    public global: GlobalComponent,
    public purchaseListService: PurchaseListService,
    public toastService: ToastrService,
    public datepipe: DatePipe,
    public fb: FormBuilder,
    public general: GeneralService,
    public commonhttp: CommonHttpService
  ) {
    this.gridPurchase = this.purchaseListService;
    if (this.global.OnboardingLoginType != "onboardLogin") {
      this.global.checkforlogout();
    } else {
      this.global.checkforonBoardLogout();
    }
    this.global.checkforlogout();

    this.form = fb.group({
      zipCode: [""],
      phone: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      email: ["", [Validators.required, Validators.email]],
    });
  }
fp:functionpermission=new functionpermission()
  ngOnInit(): void {
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") 
     {
      return;
    }
    if(this.global.globalAgencyId==undefined || this.global.globalAgencyId=="" || this.global.globalAgencyId==null|| this.global.globalAgencyId=="00000000-0000-0000-0000-000000000000")
{
  if(this.global.OnboardingLoginType != "onboardLogin"){
this.showNoAgenyError=true
  }
}
else{
  this.showNoAgenyError=false
}
    this.filterSettings = { type: "Menu" };
    this.formatDateOptions = { type: "datetime", format: "MM/dd/yyyy" };
    this.initialPage = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 10,
      pageSize: this.pageSizes[0],
      pageSizes: this.pageSizes,
    };
    
    if (this.purchaseEmit.clientToPurchase) {
      this.purchaselistBo.clientId = this.purchaseEmit.clientid;
      this.getPurchaseGridlist();
    } else {
      this.getPurchaseGridlist();
    }
    if (this.global.OnboardingLoginType != "onboardLogin") {
      this.getClientList();
    }
    this.GetPurchaseTypeLov();
    this.getVendorList();
    this.GetPurchaseStatusLov();
    this.getstatus();
    this.commonhttp
      .getJSON()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.stateList = data;
      });
      this.getpermission()
  }
  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    if(this.purchaseEmit.clientToPurchase){
      params.append("pagecode", "Client");

    }
    else{
      params.append("pagecode", "PURCHASELIST");
    }
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.purchaseService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}

  statuslist: any;
  getstatus() {
    let params = new URLSearchParams();
    params.append("listCode", "STATUS");
    this.purchaseService
      .getLov(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.statuslist = JSON.parse(data);
        this.vendor.statusLid = this.statuslist.filter(
          (st) => st.lovCode == "ACTIVE"
        )[0].id;
      });
  }

  clickaddpurchase() {
    this.purchaseBO = new PurchaseRequestBO();
    this.purchaseFileBo = new PurchaseReceiptBO();
    this.payer = "";
    this.serviceName = "";
    this.isview = false;
    this.AuthList = [];
    this.purchaseType=""
    this.changeModalSizeMd();
  }
  getClientList() {
    this.purchaseService
      .getClientDropdown()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.clientList = data;
        if (this.purchaseEmit.clientToPurchase) {
          this.purchaseBO.clientId = this.purchaseEmit.clientid;
          this.purchaseClientName = this.clientList.filter(
            (s) => s.Key == this.purchaseEmit.clientid
          )[0].Value;
        }
      });
  }
  getAuthList() {
   
    let date = this.purchaseBO.requestDate;
    date =
      date != null && date != undefined && date != ""
        ? this.global.getDateTimeString(date)
        : null;
    if (date != null && date != undefined && date != "") {
      let params = new URLSearchParams();
      if (this.purchaseEmit.clientToPurchase) {
        params.append("ClientId", this.purchaseEmit.clientid);
      }
      params.append("dateTime", date);
      this.purchaseService
        .GetAuthForPurchaseRequest(params)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data) => {
            this.AuthList = [];
            
            this.AuthList = JSON.parse(data);
            // var purchaseModal=
           this.changeModalSizeXl();
          },
          (err: HttpErrorResponse) => {
            this.toastService.error(err.error, "error");
            setTimeout(() => {
              this.toastService.clear();
            }, 8000);
          }
        );
    }
    else{
      this.AuthList=[]
      this.payer=""
      this.serviceName=""

    }
  }
  clearInputFeild(){
    if(this.purchaseBO.requestDate==null||this.purchaseBO.requestDate==undefined||this.purchaseBO.requestDate==''){
      this.payer=""
      this.serviceName=""
      this.purchaseBO=new PurchaseRequestBO();
    }
     
  }
  savePurchase() {
    
    this.purchaseBO.requestDate =
      this.purchaseBO.requestDate != null &&
      this.purchaseBO.requestDate != undefined &&
      this.purchaseBO.requestDate != ""
        ? this.global.getDateTimeString(this.purchaseBO.requestDate)
        : null;
    this.purchaseBO.requestStatusLid = this.PurchaseStatusList.filter(
      (s) => s.lovCode == "PENDING"
    )[0].id;

    let body = new FormData();
    if (this.purchaseEmit.clientToPurchase) {
      body.append("clientId", this.purchaseEmit.clientid);
    }
    body.append("requestDate", this.purchaseBO.requestDate);
    body.append("clientAuthorizationId", this.purchaseBO.clientAuthorizationId);
    body.append("serviceId", this.purchaseBO.serviceId);
    if (
      this.purchaseBO.item != null &&
      this.purchaseBO.item != undefined &&
      this.purchaseBO.item != ""
    ) {
      body.append("item", this.purchaseBO.item);
    }
    if (
      this.purchaseBO.description != null &&
      this.purchaseBO.description != undefined &&
      this.purchaseBO.description != ""
    ) {
      body.append("description", this.purchaseBO.description);
    }
    body.append("quantity", this.purchaseBO.quantity.toString());
    body.append("rate", this.purchaseBO.rate.toString());
    body.append("totalAmount", this.purchaseBO.totalAmount.toString());
    body.append("purchaseTypeLid", this.purchaseBO.purchaseTypeLid);
    body.append("requestStatusLid", this.purchaseBO.requestStatusLid);
    if (
      this.purchaseBO.vendorId != null &&
      this.purchaseBO.vendorId != undefined &&
      this.purchaseBO.vendorId != ""
    ) {
      body.append("vendorId", this.purchaseBO.vendorId);
    }
    body.append("attachMent", this.purchaseBO.attachMent);
    this.purchaseService
      .savePurchaseRequest(body)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.toastService.success("Purchase Request Saved Successfully");
          document.getElementById("PurchaseModalopen").click();
          this.getPurchaseGridlist();
         
        },
        (err: HttpErrorResponse) => {
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);
        }
      );
  }
  GetPurchaseTypeLov() {
    let params = new URLSearchParams();
    params.append("ListCode", "TYPEOFPURCHASE");
    this.purchaseService
      .getLov(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.purchaseTypeList = JSON.parse(data);
        },
        (err: HttpErrorResponse) => {
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);
        }
      );
  }

  GetPurchaseStatusLov() {
    let params = new URLSearchParams();
    params.append("ListCode", "PURCHASEREQUESTSTATUS");
    this.purchaseService
      .getLov(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.PurchaseStatusList = JSON.parse(data);
        },
        (err: HttpErrorResponse) => {
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);
        }
      );
  }
  getVendorList() {
    this.purchaseService
      .getVendorList()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.vendorList = JSON.parse(data);
        },
        (err: HttpErrorResponse) => {
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);
        }
      );
  }
  showLocationColumns() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }

  newdates(event, type, name) {
    if (type == "inputchange") {
      if (name == "date") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.purchaseBO.requestDate = val1;
        }
      }
    }
    if (type == "datechanged") {
      if (name == "date") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.purchaseBO.requestDate = val1;
         
        }
      }
    }
    
  }

  purchaseTypeFilter(data) {
    if (data != null && data != undefined && data != "") {
      this.purchaseType = this.purchaseTypeList.filter(
        (s) => s.id == data
      )[0].lovName;
    } else {
      this.purchaseType = "";
    }
  }

  getauthoraization(val) {
    this.serviceName = val.serviceName;
    this.payer = val.payerName;
    this.purchaseBO.serviceId = val.serviceId;
    this.purchaseBO.description = val.serviceDescription;
    this.purchaseBO.clientAuthorizationId = val.clientAuthorizationId;
  }

  getPurchaseGridlist() {
    this.purchaseListService.execute(this.purchaselistBo);
    this.gridPurchase.pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {},
      (err: HttpErrorResponse) => {
        this.toastService.error(err.error, "error");
        setTimeout(() => {
          this.toastService.clear();
        }, 8000);
      }
    );
  }

  onDOCFileChanged(files) {
    let val = files.item(0);
    const formData: FormData = new FormData();
    formData.append("file", val, val.name.toString());
    this.purchaseBO.attachMent = files.item(0);
  }

  getTotal() {
    if (
      this.purchaseBO.quantity != null &&
      this.purchaseBO.quantity != undefined &&
      this.purchaseBO.rate != undefined &&
      this.purchaseBO.rate != null
    ) {
      this.purchaseBO.totalAmount =
        (this.purchaseBO.quantity * this.purchaseBO.rate).toFixed(2);
    }
  }

  clickEditview(purchaseData: PurchaseRequestBO) {
    this.changeModalSizeMd();
    this.purchaseBO = JSON.parse(JSON.stringify(purchaseData));
    this.purchaseId = purchaseData.id;
    this.getAuthId = purchaseData.clientAuthorizationId;
    this.purchaseClientName = purchaseData.clientName;
    this.purchaseBO.requestDate = this.datepipe.transform(
      purchaseData.requestDate,
      "MM/dd/yyyy"
    );
    this.serviceName = purchaseData.serviceName;
    this.payer = purchaseData.payerName;
    this.fileUpload=purchaseData?.fileName
    this.isview = true;
    this.purchaseTypeFilter(purchaseData.purchaseTypeLid);
    this.purchaseBO.vendorId = this.vendorList.filter(
      (st) => st.id == purchaseData.vendorId
    )[0]?.id;
  }

  

  downloadFile() {
    var data1 = this.purchaseBO.returnDocument;
    if (data1 != null) {
      window.open(data1);
    }
  }

  clickClose() {
    this.purchaseBO = new PurchaseRequestBO();
   
  }
  AcceptRequest() {
    let params = new URLSearchParams();
    params.append("PurchaseId", this.purchaseId);
    params.append("ClientId", this.getAuthId);

    this.purchaseService
      .AcceptPurchaseRequest(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          if (data) {
            this.acceptError = data;

            document.getElementById("Authmodal").click();
          } else {
            this.toastService.success("Request Accepted Successfully");
            document.getElementById("AcceptModal").click();
            this.getPurchaseGridlist();
          }
        },
        (err: HttpErrorResponse) => {
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);
        }
      );
  }

  RejectRequest() {
    let params = new URLSearchParams();
    params.append("PurchaseId", this.purchaseId);
    this.purchaseService
      .RejectPurchaseRequest(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.toastService.success("Request Rejected Successfully");
          this.purchaseId = "";
          document.getElementById("RejectModal").click();
          this.getPurchaseGridlist();
        },
        (err: HttpErrorResponse) => {
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);
        }
      );
  }

  saveAccept() {
    let params = new URLSearchParams();
    params.append("PurchaseId", this.purchaseId);
    params.append("ClientId", this.getAuthId);
    this.purchaseService
      .AcceptAfterError(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.toastService.success("Request Accepted Successfully");

          this.purchaseId = "";
          document.getElementById("Authmodal").click();
          document.getElementById("AcceptModal").click();
          this.getPurchaseGridlist();
        },
        (err: HttpErrorResponse) => {
          this.toastService.error(err.error, "error");
          setTimeout(() => {
            this.toastService.clear();
          }, 8000);
        }
      );
  }

  filterApply() {
    this.getPurchaseGridlist();
  }

  Refresh() {
    if (this.purchaseEmit.clientToPurchase) {
      this.purchaselistBo.clientId = this.purchaseEmit.clientid;
      this.purchaselistBo.purchaseTypeLid = null;
      this.purchaselistBo.requestStatusLid = null;
      this.getPurchaseGridlist();
    } else {
      this.purchaselistBo.clientId = null;
      this.purchaselistBo.purchaseTypeLid = null;
      this.purchaselistBo.requestStatusLid = null;
      this.getPurchaseGridlist();
    }
  }

  public onActionComplete(G) {
    this.purchaselistBo.currentpageno =
      this.grid.pagerModule.pagerObj.currentPage;
    this.purchaselistBo.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    if (G.name == "actionBegin" && G.requestType == "filterbeforeopen") {
      this.purchaselistBo.type = G.columnType;
    }
  }

  public dataStateChange(state): void {
    this.documentType = state.action.requestType.toString();
    if (this.documentType != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.purchaselistBo.orderColumn = state.sorted[0].name;
        this.purchaselistBo.orderType =
          state.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (
      this.documentType == "filtering" &&
      state.action.action != "clearFilter"
    ) {
      this.purchaselistBo.field = state.action.currentFilterObject.field;
      this.purchaselistBo.matchCase =
        state.action.currentFilterObject.matchCase;
      this.purchaselistBo.operator = state.action.currentFilterObject.operator;
      this.purchaselistBo.value = state.action.currentFilterObject.value;
      this.purchaselistBo.orderColumn =
        state.action.currentFilterObject.orderColumn;
    } else {
      if (
        this.documentType == "filtering" &&
        state.action.action == "clearFilter"
      ) {
        this.purchaselistBo.field = "clientName";
        this.purchaselistBo.matchCase = false;
        this.purchaselistBo.operator = "startswith";
        this.purchaselistBo.value = "";
        this.purchaselistBo.orderColumn = "clientName";
      }
    }
    this.getPurchaseGridlist();
  }
  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  PhoneFormat(value) {
    if (value == "phone") {
      this.vendor.phone = this.general.converPhoneGoogleLib(this.vendor.phone);
    }
  }
  CaseCreateupdate() {
    this.vendor = new VendorBO();
  }

  SaveVendor() {
    if (this.vendor.id == "00000000-0000-0000-0000-000000000000") {
      var saveList: VendorBO = JSON.parse(JSON.stringify(this.vendor));
      this.purchaseService
        .saveupdateVendor(saveList)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.toastService.success("saved  Successfully", "vendor saved");
            document.getElementById("opencasemanModal1").click();
            this.getVendorList();
          },
          (err) => {
            this.toastService.error(err.error);
          }
        );
    }
  }
  rowSelected(args: RowSelectEventArgs) {
    var rowList: any = args.data;
    this.serviceName = rowList.serviceName;
    this.payer = rowList.payerName;
    this.purchaseBO.serviceId = rowList.serviceId;
    this.purchaseBO.description = rowList.serviceDescription;
    this.purchaseBO.clientAuthorizationId = rowList.clientAuthorizationId;
  }
  ngAfterContentChecked() {
    // this.purchaseBO.requestDate =(this.purchaseBO.requestDate != null &&this.purchaseBO.requestDate != undefined && this.purchaseBO.requestDate != "") ? this.datepipe.transform(this.purchaseBO.requestDate, "MM/dd/yyyy"): null;
    this.cdr.detectChanges();
  }

  changeModalSizeXl(){
    let doc = document.getElementById('smallModal');
    doc.classList.remove('modal-lg');
    doc.classList.add('modal-xl')

    let getcol= document.getElementById("fisrtcol");
    getcol.classList.remove('col-12');
    getcol.classList.add('col-6');
  }
  changeModalSizeMd(){
    let doc = document.getElementById('smallModal');
    doc.classList.remove('modal-xl');
    doc.classList.add('modal-lg')
    let getcol= document.getElementById("fisrtcol");    
    getcol.classList.remove('col-6');
    getcol.classList.add('col-12');
  }


  exportCsv() {
    this.purchaseService.exportcsv(this.purchaselistBo).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

    let contentType = 'text/csv';
    const blob = this.b64toBlob(data.fileContents, contentType);
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = "Purchase Export";
    a.click();
   
    },
    (err: HttpErrorResponse) => {
      this.toastService.error(
        err.error

      );
    })

  }

   b64toBlob = (b64Data, contentType:any, sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  


}

